import {
  SINGLE,
  SIDE_BY_SIDE,
  GRID,
  FEATURED_PRESENTER,
  FEATURED_SCREEN,
  FEATURED_MEDIA,
  SCREEN_PRESENTER_LIMIT,
  CAMERA_PRESENTER_LIMIT,
  SceneLayouts,
  ALL_LAYOUTS
} from '@shoflo/polymer/constants/SceneLayouts';

export default SceneLayouts;

export {
  SINGLE,
  SIDE_BY_SIDE,
  GRID,
  FEATURED_PRESENTER,
  FEATURED_SCREEN,
  FEATURED_MEDIA,
  SCREEN_PRESENTER_LIMIT,
  CAMERA_PRESENTER_LIMIT,
  ALL_LAYOUTS
};
